// compatible with global
// 目前浏览器环境、Jest环境(jsDom)都有global
// node环境先简单mock一下。   后续补齐 or 是不是node环境也jsDom处理一下呢？
var MOCK_GLOBAL = {};
function isInBrowser() {
    return typeof window !== 'undefined';
}
function isInNodeJS() {
    return typeof global !== 'undefined';
}
function isInWebWorker() {
    return !isInBrowser && typeof self !== 'undefined';
}
function isInJestEnv() {
    return isInNodeJS() && typeof global.describe === 'function';
}
/**
 * 获取全局变量
 */
function getGlobalObject() {
    if (isInBrowser()) {
        return window;
    }
    if (isInNodeJS()) {
        return global;
    }
    if (isInWebWorker()) {
        return self;
    }
    if (isInJestEnv()) {
        return MOCK_GLOBAL;
    }
    return MOCK_GLOBAL;
}
var browserUtilsGlobal = getGlobalObject();
export default browserUtilsGlobal;
